import { useSite } from "../../context/SiteContext";

export default function Marquee() {
  const { content } = useSite();
  const items = content?.marquee || [];
  if (!items.length) return null;
  const row = [...items, ...items];
  return (
    <div className="bg-sand border-y border-gold/25 py-4 overflow-hidden" data-testid="locations-marquee">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((item, i) => (
          <span key={i} className="inline-flex items-center gap-6 mx-6 text-sm uppercase tracking-[0.25em] text-cocoa">
            {item}
            <span className="text-gold text-xs">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
